/**
 * Client entry point: mount React, wrap in providers and the router.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "@/App";
import { PreferencesProvider } from "@/app/preferences";
import { SessionProvider } from "@/app/session";

import "@/index.css";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element #root not found");
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <PreferencesProvider>
        <SessionProvider>
          <App />
        </SessionProvider>
      </PreferencesProvider>
    </BrowserRouter>
  </StrictMode>,
);
